import Moment from "react-moment";

export default function Executive({
  approver,
  type,
  email,
  handleRemarks,
  auth,
}: any) {
  if(auth?.accessLevel !== 5 && auth?.accessLevel !== 9){
    if (approver?.email !== email || !approver?.email) return <></>;
  }
  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 flex justify-between items-start px-2">
      <div className="bg-white mb-2 flex flex-col w-full">
        <div className=" flex justify-between p-2">
          <div className="flex flex-col sm:flex-row justify-between w-full">
            <div className="font-bold">
              <div className="">{approver?.name}</div>
              <div className="text-gray-500" style={{ fontSize: 10 }}>
                Email: {approver?.email || "-"}
              </div>
            </div>
            {auth?.email === approver?.email && (
              <div className="flex">
                <button
                  onClick={() => handleRemarks({ approver, type })}
                  className="border py-1 bg-gray-100 px-6 mx-1"
                >
                  Remarks
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="px-2 pb-2 pt-1 flex flex-col justify-between text-xs">
          <div className="" style={{ fontSize: 12 }}>
            Remarks: {approver?.remarks || "-"}
          </div>
          {approver?.date ? (
            <div className="flex justify-between text-gray-600 mr-1">
              <Moment format={"Do, MMM, YYYY"}>{approver?.date}</Moment>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
